export enum SortErgebnisEnum {
  Versicherer = 'Versicherer',
  Beitrag = 'Beitrag',
  Bewertung = 'Bewertung',
}
